var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Battery" }, [
    _vm.level >= 75
      ? _c("div", { staticClass: "battery" }, [
          _c("div", {
            staticClass: "battery-level",
            staticStyle: { height: "100%" },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.level < 75 && _vm.level > 50
      ? _c("div", { staticClass: "battery" }, [
          _c("div", {
            staticClass: "battery-level",
            staticStyle: { height: "75%" },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.level <= 50 && _vm.level > 25
      ? _c("div", { staticClass: "battery" }, [
          _c("div", {
            staticClass: "battery-level",
            staticStyle: { height: "50%" },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.level <= 25 && _vm.level > 18
      ? _c("div", { staticClass: "battery" }, [
          _c("div", {
            staticClass: "battery-level",
            staticStyle: { height: "25%" },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.level <= 18 && _vm.level > 10
      ? _c("div", { staticClass: "battery" }, [
          _c("div", {
            staticClass: "battery-level battery-warn",
            staticStyle: { height: "18%" },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.level < 10
      ? _c("div", { staticClass: "battery" }, [
          _c("div", {
            staticClass: "battery-level battery-alert",
            staticStyle: { height: "10%" },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }